// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2XiqE","fullView":"styles_fullView__1hXaX"};